import { SVGProps } from 'react'

export const PauseVideoCircleloader = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {/* Background white circle */}
    <circle cx="20" cy="20" r="18.5" fill="white" />

    {/* Move origin to center, then rotate inner group around (0,0) */}
    <g transform="translate(20 20)">
      <g>
        <circle
          cx="0"
          cy="0"
          r="18.5"
          fill="none"
          stroke="url(#paint0_linear_19145_39470)"
          strokeWidth={3}
          strokeDasharray="38.7 77.5" /* ~1/3 arc visible */
          strokeLinecap="round"
        />
        {/* rotate the inner group around its origin (which is now the SVG center) */}
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          from="0"
          to="360"
          dur="1.5s"
          repeatCount="indefinite"
        />
      </g>
    </g>

    {/* Static pause icon at center */}
    <g clipPath="url(#clip0_19145_39470)">
      <rect width="20" height="20" transform="translate(10 10)" fill="white" />
      <path
        d="M17.917 22.5V17.5M22.0837 22.5V17.5M28.3337 20C28.3337 24.6023 24.6027 28.3333 20.0003 28.3333C15.398 28.3333 11.667 24.6023 11.667 20C11.667 15.3976 15.398 11.6666 20.0003 11.6666C24.6027 11.6666 28.3337 15.3976 28.3337 20Z"
        stroke="#F04438"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>

    <defs>
      <linearGradient
        id="paint0_linear_19145_39470"
        x1="0"
        y1="0"
        x2="40"
        y2="40"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F49062" />
        <stop offset="1" stopColor="#FD371F" />
      </linearGradient>

      <clipPath id="clip0_19145_39470">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(10 10)"
        />
      </clipPath>
    </defs>
  </svg>
)
